import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  DefaultButton,
  DefaultPrimaryButton,
  InputWithLabel,
} from "../../components/micro";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import Breadcrumb from "../../components/common/Breadcrumb";
import ConfirmationModel from "../../components/common/ConfirmationModel";
import { useDispatch } from "react-redux";
import { createVideo, editVideo } from "../../redux/video/slice";

const AddEditVideo = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isEditing, setIsEditing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [formValues, setFormValues] = useState(null);
  const videoData = location?.state?.video;
  const isEditMode = location?.state?.mode;
  const handleEditClick = () => setIsEditing(true);
  const handleCancelClick = () => navigate("/video");

  // handle confirm
  const handleConfirm = async () => {
    setIsLoading(true);

    const payload = {
      videoName: formValues?.name,
      description: formValues?.description,
      videoUrl: formValues?.videourl,
    };

    const action = videoData?._id
      ? editVideo({ _id: videoData._id, ...payload })
      : createVideo(payload);

    try {
      const res = await dispatch(action);
      if (
        res.type === "createVideo/fulfilled" ||
        res.type === "editVideo/fulfilled"
      ) {
        navigate("/video");
      }
    } catch (error) {
      console.error("Error creating/updating video:", error);
    } finally {
      setIsLoading(false);
      setShowConfirmationModal(false);
    }
  };
  return (
    <>
      <div className="space-y-5">
        <div>
          <h6 className="font-Montserrat font-medium text-xl mb-3">
            {isEditMode === "edit" ? "Edit Video" : "Create Video"}
          </h6>
          <Breadcrumb
            breadCrumbParent={"Home"}
            breadCrumbParent2={"Video"}
            breadCrumbActive={
              isEditMode === "edit" ? "Edit Video" : "Create Video"
            }
            breadCrumbTitleKey={"/"}
            classes=""
          />
        </div>
        <div className="bg-white shadow-md rounded-lg p-6">
          <Formik
            initialValues={{
              name: videoData?.videoName || "",
              description: videoData?.description || "",
              videourl: videoData?.videoUrl || "",
            }}
            validationSchema={Yup.object().shape({
              name: Yup.string()
                .trim()
                .nullable()
                .required("Please enter Video name"),
              description: Yup.string()
                .trim()
                .nullable()
                .required("Please enter description"),
              videourl: Yup.string()
                .url("Please enter a valid video URL")
                .required("Please upload a video url"),
            })}
            onSubmit={(values) => {
              setFormValues(values);
              setShowConfirmationModal(true);
            }}
          >
            {({
              handleChange,
              handleBlur,
              values,
              errors,
              touched,
              setFieldValue,
            }) => {
              return (
                <>
                  <Form>
                    <div className="grid grid-cols-2 gap-6 mb-4">
                      <InputWithLabel
                        idFromName="name"
                        name="name"
                        label="Video Name*"
                        type="text"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.name}
                        errorsText={errors.name}
                        errors={errors.name && touched.name}
                        className={`${
                          errors?.name && touched?.name
                            ? `border border-red`
                            : `border border-borderTheme/80 focus-within:border-themeBtn `
                        } w-full `}
                        disabled={isEditMode === "edit" && !isEditing}
                      />
                      <InputWithLabel
                        idFromName="videourl"
                        name="videourl"
                        label="Video URL*"
                        type="text"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.videourl}
                        errorsText={errors.videourl}
                        errors={errors.videourl && touched.videourl}
                        className={`${
                          errors?.videourl && touched?.videourl
                            ? `border border-red`
                            : `border border-borderTheme/80 focus-within:border-themeBtn `
                        } w-full `}
                        disabled={isEditMode === "edit" && !isEditing}
                      />
                      <InputWithLabel
                        idFromName="description"
                        name="description"
                        label="Description*"
                        type="textarea"
                        rows={1}
                        onChange={handleChange}
                        setFieldValue={setFieldValue}
                        maxWords={150}
                        minWords={3}
                        onBlur={handleBlur}
                        value={values.description}
                        errorsText={errors.description}
                        errors={errors.description && touched.description}
                        className={`${
                          errors?.description && touched?.description
                            ? `border border-red`
                            : `border border-borderTheme/80 focus-within:border-themeBtn `
                        } w-full `}
                        disabled={isEditMode === "edit" && !isEditing}
                      />
                    </div>
                    <div className="flex justify-end gap-3 mt-3">
                      <DefaultPrimaryButton
                        type="button"
                        value={isEditMode === "edit" ? "Back" : "Cancel"}
                        onClick={handleCancelClick}
                      />
                      {isEditMode === "edit" ? (
                        isEditing ? (
                          <>
                            <DefaultButton
                              type="submit"
                              value="Save"
                              onClick={(e) => {}}
                            />
                          </>
                        ) : (
                          <DefaultButton
                            value="Edit"
                            onClick={handleEditClick}
                            type="submit"
                          />
                        )
                      ) : (
                        <>
                          <DefaultButton type="submit" value="confirm" />
                        </>
                      )}
                    </div>
                  </Form>
                </>
              );
            }}
          </Formik>
        </div>
      </div>
      {showConfirmationModal && (
        <ConfirmationModel
          confirmText={isEditMode === "edit" ? "Edit" : "Create"}
          onClose={() => setShowConfirmationModal(false)}
          onConfirm={handleConfirm}
          isLoading={isLoading}
        />
      )}
    </>
  );
};

export default AddEditVideo;
